import React from 'react'
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import Grid from '@mui/material/Grid';

class Help extends React.Component {

    showContactPage = () => {
        this.props.showPopup("contactInfoPopup")
    }

    showDemoPopup = (event) => {
        event.preventDefault()
        this.props.showPopup("demoPopup")
    }

    render() {
        return (
            <div className="mainWrapper">
                <div className="bodyPart">
                    <div className="contentWrapper">
                        <h2 className="pageHead">
                            <LiveHelpIcon />
                            {' '}
                            Help
                            <div className="rightButton">
                                <button className="btn" onClick={this.showContactPage}>Contact Us</button>
                            </div>
                        </h2>
                        <h3 className="subHeadInner">
                            Introducing Our New Feature
                        </h3>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <p className="topSpace">We are proud to announce a new feature <strong>'Story Builder'</strong>.</p>
                                <p>XP3 BI Cloud current version allows users to securely login, search for a presentation and then customize the presentation easily with Quick Picks functionality.</p>
                                <p>With this new feature, XP3 BI Cloud users will be able to easily create and manage their stories based on an existing master presentation. Users now can select just the slides that they need from the master presentation before using Quick Picks functionality. Users can also move, delete or duplicate slides in their stories.</p>
                                <p>Please take a look at the video below to review this new 'Story Builder' feature.</p>
                                <div style={{ "margin": "15px auto", "width": "50%", "border": "1px solid #eaeaea" }}>
                                    <video width="100%" controls>
                                        <source src="https://iedemostorage.z20.web.core.windows.net/storybuilder.mp4" type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        )
    }
}

export default Help